import React from 'react';

const PutniNalogStrana2 = () => {

  return (
        <table className="rotated-table">
              <colgroup>
              <col className="col0" />
              <col className="col1" />
              <col className="col2" />
              <col className="col3" />
              <col className="col4" />
              <col className="col5" />
              <col className="col6" />
              <col className="col7" />
              <col className="col8" />
              <col className="col9" />
              <col className="col10" />
              <col className="col11" />
              <col className="col12" />
              <col className="col13" />
              <col className="col14" />
              <col className="col15" />
              <col className="col16" />
              <col className="col17" />
              <col className="col18" />
              <col className="col19" />
              <col className="col20" />
              <col className="col21" />
              <col className="col22" />
              <col className="col23" />
            </colgroup>
            
            <tbody>
              {/* Prvi red - Potrošnja goriva i zaglavlje */}
              <tr className="row25">
                <td className="column0 displayTextFlex verticalAlign" colSpan="2" rowSpan="3">Datum</td>
                <td className="column2 displayTextFlex verticalAlign wrapCell" colSpan="2" rowSpan="3" >Stanje brojila</td>
                <td className="column4 displayTextFlex verticalAlign" colSpan="4" rowSpan="3"  >Mesto polaska</td>
                <td className="column8 displayTextFlex verticalAlign borderSecondTable" colSpan="4">VREME</td>
                <td className="column12 displayTextFlex verticalAlign borderSecondTable" colSpan="6" rowSpan="3">Uzrok stajanja vozila</td>
                <td className="column18 displayTextFlex verticalAlign" colSpan="4">Pređeno km</td>
                <td className="column22 displayTextFlex verticalAlign" colSpan="2" rowSpan="3">TEŽINA (t)</td>
              </tr>

              <tr className="row25">
                <td className="column8 displayTextFlex verticalAlign borderSecondTable" colSpan="2">Polaska</td>
                <td className="column10 displayTextFlex verticalAlign borderSecondTable" colSpan="2">Dolaska</td>
                <td className="column18 displayTextFlex verticalAlign" colSpan="2" rowSpan="2">sa teretom</td>
                <td className="column20 displayTextFlex verticalAlign" colSpan="2" rowSpan="2">bez tereta</td>
              </tr>
              <tr className="row25">
                <td className="column8 displayTextFlex verticalAlign borderSecondTable">čas</td>
                <td className="column9 displayTextFlex verticalAlign borderSecondTable">min</td>
                <td className="column10 displayTextFlex verticalAlign borderSecondTable">čas</td>
                <td className="column11 displayTextFlex verticalAlign borderSecondTable">min</td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className="rowHeigth grow-row">
                <td className="column0 empty-cell" colSpan="2"></td>
                <td className="column2 empty-cell" colSpan="2"></td>
                <td className="column4 empty-cell" colSpan="4"></td>
                <td className="column8 empty-cell borderSecondTable"></td>
                <td className="column9 empty-cell borderSecondTable"></td>
                <td className="column10 empty-cell borderSecondTable"></td>
                <td className="column11 empty-cell borderSecondTable"></td>
                <td className="column12 empty-cell borderSecondTable" colSpan="6"></td>
                <td className="column18 empty-cell" colSpan="2"></td>
                <td className="column20 empty-cell" colSpan="2"></td>
                <td className="column22 empty-cell" colSpan="2"></td>
              </tr>
              <tr className='borderBottomNone'>
                <td className="column0 borderBottomNone row25 paddingLeft10px" colSpan="24" style={{ borderBottom:  'none !important'}}>Napomena vozača:</td>

              </tr>
              <tr className='borderBottomNone borderTopNone row25'>
                <td className="column0 displayTextFlex borderBottomNone borderTopNone" colSpan="24" style={{ borderTop:  'none !important'}}></td>
              </tr>
              <tr className='borderBottomNone borderTopNone row25' style={{borderTop: 'none !important', borderBottom:  'none !important'}}>
                <td className="column0 empty-cell borderBottomNone borderTopNone borderRightNone" colSpan="18" style={{borderTop: 'none !important',borderBottom: "none !important", borderRight: "none !important"}}></td>
                <td className="column18 empty-cell borderTopNone borderRightNone borderLeftNone" colSpan="2" style={{borderTop: 'none !important',borderBottom: "1px solid black", borderLeft: "none !important", borderRight: "none !important"}}></td>
                <td className="column20 empty-cell borderTopNone borderRightNone borderLeftNone" colSpan="2" style={{borderTop: 'none !important',borderBottom: "1px solid black", borderLeft: "none !important", borderRight: "none !important"}}></td>
                <td className="column22 empty-cell borderTopNone borderRightNone borderLeftNone" style={{borderTop: 'none !important', borderBottom: "1px solid black", borderLeft: "none !important", borderRight: "none !important"}}></td>
                <td className="column23 empty-cell borderTopNone borderBottomNone borderLeftNone" style={{borderTop: 'none !important', borderBottom: "none !important", borderLeft: "none !important"}}></td>
              </tr>
              <tr className='borderTopNone row25' style={{borderTop: 'none !important'}}>
                <td className="column0 empty-cell borderTopNone borderRightNone" colSpan="18" style={{borderTop: 'none !important', borderRight: "none !important"}}></td>
                <td style={{borderTop: 'none !important', borderLeft: 'none !important', borderRight: "none !important"}} className="column18 borderTopNone borderRightNone borderLeftNone displayTextFlex" colSpan="5">Potpis vozača:</td>
                <td className="column23 empty-cell borderTopNone borderLeftNone"  style={{borderTop: 'none !important', borderLeft: 'none !important',borderRight: "none !important"}}></td>
              </tr>
            </tbody>
        </table>
  );
};

export default PutniNalogStrana2;